import Vue from 'vue'
import Router from 'vue-router'
import coursePage from '@/components/course/coursePage'
import searchPageAlt from '@/components/searchPage/searchPageAlt'
import home from '@/components/home/home'
import cart from '@/components/cart/cart'
import wallet from '@/components/wallet/wallet'
import profile from '@/components/profile/profile'
import allCourses from '@/components/course/allCourses'
import wishList from '@/components/wishList/wishList'
import myCourses from '@/components/myCourses/myCourses'
import playlist from '@/components/playList/playlist'
import frames from '@/components/contentViewer/frames'
import confirmation from '@/components/cart/confirmation'
import success from '@/components/cart/success'
import liveDemyLogout from '@/components/logout/liveDemyLogout'
import advertisementPage from '@/components/advertisement/advertisementPage'
import mobileHome from '@/components/mobileHome'
import mahademyHome from '@/components/mahademyHome'
import Toasted from 'vue-toasted'

Vue.use(Router)
Vue.use(Toasted, {
  duration: 3200,
  theme: 'primary'
})

export default new Router({
  routes: [{
    path: '/coursePage/:contentId/:title?',
    name: 'coursePage',
    component: coursePage,
    meta: {requireAuth: false}
  },
  {
    path: '/advertisement',
    name: 'advertisementPage',
    component: advertisementPage,
    meta: {requireAuth: false}
  },
  {
    path: '/cart',
    name: 'cart',
    component: cart,
    meta: {requireAuth: true}
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    component: home,
    meta: {requireAuth: false}
  },
  {
    path: '/searchPageAlt',
    name: 'searchPageAlt',
    component: searchPageAlt,
    meta: {requireAuth: false}
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: wallet,
    meta: {requireAuth: true}
  },
  {
    path: '/profile',
    name: 'profile',
    component: profile,
    meta: {requireAuth: true}
  },
  {
    path: '/allCourses',
    name: 'allCourses',
    component: allCourses,
    meta: {requireAuth: true}
  },
  {
    path: '/wishList',
    name: 'wishList',
    component: wishList,
    meta: {requireAuth: true}
  },
  {
    path: '/mycourses',
    name: 'myCourses',
    component: myCourses,
    meta: {requireAuth: true}
  },
  {
    path: '/playlist',
    name: 'playlist',
    component: playlist,
    meta: {requireAuth: true}
  },
  {
    path: '/frames',
    name: 'frames',
    component: frames,
    meta: {requireAuth: true}
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: confirmation,
    meta: { requireAuth: true }
  },
  {
    path: '/success/:transactionId/:amount/:status',
    name: 'success',
    component: success,
    meta: { requireAuth: true }
  },
  {
    path: '/livedemylogout',
    name: 'liveDemyLogout',
    component: liveDemyLogout,
    meta: { requireAuth: false }
  },
  {
    path: '/mobileHome/:token',
    name: 'mobileHome',
    component: mobileHome,
    meta: {requireAuth: true}
  },
  {
    path: '/mahademyHome/:token',
    name: 'mahademyHome',
    component: mahademyHome,
    meta: {requireAuth: true}
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js